import { images } from '../constants';

const products = [
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Wedding Rings",
        price: 499.99,
        disprice: 429.99,
        stock: 9,
        content: "Celebrate eternal love with our finely crafted wedding rings, symbolizing commitment and unity. Designed with elegance and made from high-quality materials, each ring offers a timeless charm for your special day.",
        description: "These wedding rings are expertly designed to reflect everlasting love and sophistication. Whether you prefer classic gold, sleek platinum, or sparkling stones, our collection ensures the perfect match for every couple.",
        category: ["Wedding Jewelry", "Bridal Accessories"],
        tags: ["Rings", "Jewelry", "Accessories"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Materials", content: "Gold, Platinum, Diamonds (optional)" },
            { id: 2, title: "Size Range", content: "US 4 to US 13" }
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "Sophia Miller",
                date: "Mar 21, 2024",
                rating: 5,
                content: "Absolutely stunning rings! We couldn’t be happier with the quality and design."
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Daniel Turner",
                date: "Feb 11, 2024",
                rating: 4,
                content: "Elegant and well-crafted. Slight delay in delivery, but worth the wait."
            }
        ]
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "Wedding Shoes",
        price: 129.99,
        disprice: 99.99,
        stock: 5,
        content: "Step into elegance with our wedding shoes, crafted for comfort and style. Perfect for brides, bridesmaids, or wedding guests, each pair offers beautiful detailing and a supportive fit to keep you dancing all night long.",
        description: "Our wedding shoes combine fashion and function—featuring cushioned soles, graceful silhouettes, and sparkling accents. From heels to flats, find your perfect pair for the big day.",
        category: ["Bridal Accessories", "Wedding Favors"],
        tags: ["Shoes", "Footwear", "Bridal"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Materials", content: "Satin, Leather, Cushioned Insole" },
            { id: 2, title: "Available Sizes", content: "US 5 to US 11" }
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "Emma Williams",
                date: "May 2, 2024",
                rating: 5,
                content: "Super comfy and so elegant! I wore them the whole day without pain."
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Lily Adams",
                date: "Apr 17, 2024",
                rating: 4,
                content: "Beautiful design, but they run a little small. Order half a size up!"
            }
        ]
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Diamond Earrings",
        price: 349.99,
        disprice: 299.99,
        stock: 3,
        content: "Add a touch of brilliance to your wedding look with our diamond earrings. Expertly cut and set in elegant designs, these earrings sparkle with timeless beauty, making them the perfect accessory for your big day.",
        description: "Our diamond earrings are designed to elevate your bridal style with their classic shine and graceful charm. Whether you're going for a traditional or modern look, these earrings complement every outfit with subtle luxury.",
        category: ["Wedding Jewelry", "Bridal Accessories"],
        tags: ["Earrings", "Jewelry", "Accessories"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Materials", content: "14K Gold, Certified Diamonds" },
            { id: 2, title: "Stone Cut", content: "Round Brilliant" }
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "Natalie King",
                date: "Mar 30, 2024",
                rating: 5,
                content: "These earrings are stunning! I wore them on my wedding day and got so many compliments."
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Hannah Ross",
                date: "Feb 15, 2024",
                rating: 4,
                content: "Beautiful sparkle and very elegant. Slightly smaller than I expected, but still love them!"
            }
        ]
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Key Chains",
        price: 14.99,
        disprice: 9.99,
        stock: 0,
        content: "Commemorate your special day with our stylish key chains, perfect as wedding favors or keepsakes. Crafted with charm and meaning, these accessories make thoughtful gifts for your guests or bridal party.",
        description: "Our wedding-themed key chains blend practicality with sentiment. Choose from elegant initials, romantic symbols, or personalized designs that celebrate your big day with a lasting touch.",
        category: ["Wedding Favors", "Personalized Gifts"],
        tags: ["Keychains", "Accessories", "Gifts"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Stainless Steel / Acrylic" },
            { id: 2, title: "Customization", content: "Available (Names, Dates, Initials)" }
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "Olivia Harris",
                date: "Jan 10, 2024",
                rating: 5,
                content: "Perfect as wedding favors! Our guests loved the custom initials."
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Jacob Moore",
                date: "Dec 5, 2023",
                rating: 4,
                content: "Very cute and well-made. Shipping took a bit longer than expected."
            }
        ]
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Pearl Necklaces",
        price: 299.99,
        disprice: 249.99,
        stock: 8,
        content: "Elegance meets timeless beauty with our pearl necklaces, designed to complement any bridal gown. Featuring high-quality pearls, each necklace adds a sophisticated touch to your wedding day ensemble.",
        description: "Our pearl necklaces are the epitome of classic bridal elegance. Whether you're looking for a simple strand or a statement piece with diamonds, these necklaces are the perfect accessory for a chic and polished look.",
        category: ["Wedding Jewelry", "Bridal Accessories"],
        tags: ["Necklaces", "Jewelry", "Accessories"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Materials", content: "Freshwater Pearls, 14K Gold (Optional)" },
            { id: 2, title: "Length", content: "16 inches to 18 inches" }
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "Charlotte Taylor",
                date: "Feb 22, 2024",
                rating: 5,
                content: "Such a stunning piece! Wore it on my wedding day, and it was perfect!"
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Ava Wilson",
                date: "Jan 30, 2024",
                rating: 5,
                content: "Absolutely beautiful necklace! The pearls have such a lovely shine."
            }
        ]
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Photo Frames",
        price: 39.99,
        disprice: 29.99,
        stock: 6,
        content: "Preserve the memories of your wedding day with our elegant photo frames. Crafted from high-quality materials, these frames are perfect for displaying your cherished moments from the big day.",
        description: "Our wedding photo frames are designed to showcase your special photos with style. From minimalist designs to ornate, decorative frames, these options complement every wedding theme and make beautiful gifts for loved ones.",
        category: ["Home Decor", "Personalized Gifts"],
        tags: ["Frames", "Decor", "Gifts"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Wood, Metal, Glass" },
            { id: 2, title: "Frame Sizes", content: "4x6, 5x7, 8x10" }
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "Sophia Martin",
                date: "Mar 8, 2024",
                rating: 5,
                content: "These frames are so elegant! I gifted them to my bridesmaids with photos of our wedding day."
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Lucas Adams",
                date: "Feb 20, 2024",
                rating: 4,
                content: "Great quality, though a little smaller than I expected. Still, a wonderful addition to our home."
            }
        ]
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "Custom Candles",
        price: 24.99,
        disprice: 19.99,
        stock: 2,
        content: "Light up your special day with our custom candles, perfect for wedding decor or personalized gifts. Available in various scents, colors, and designs, these candles add a warm, inviting glow to any wedding celebration.",
        description: "Our custom candles offer a unique touch to your wedding, whether as centerpieces, favors, or part of your overall decor. You can personalize them with names, dates, or special messages to make your wedding even more memorable.",
        category: ["Wedding Favors", "Personalized Gifts"],
        tags: ["Candles", "Gifts", "Personalized"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Customization", content: "Names, Dates, Messages" },
            { id: 2, title: "Scent Options", content: "Lavender, Vanilla, Rose, Jasmine" }
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "Megan Carter",
                date: "Jan 18, 2024",
                rating: 5,
                content: "These candles made perfect gifts for my bridal party! The scent was amazing, and they loved the personalization."
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Ethan Clarke",
                date: "Dec 30, 2023",
                rating: 5,
                content: "Beautiful candles! I ordered them for my wedding, and they looked fantastic on the reception tables."
            }
        ]
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Table Centerpieces",
        price: 59.99,
        disprice: 49.99,
        stock: 0,
        content: "Elevate your wedding reception with our stunning table centerpieces. Designed to add elegance and charm to your tables, these centerpieces will complement your theme and leave a lasting impression on your guests.",
        description: "Our table centerpieces are the perfect blend of beauty and sophistication, whether you're looking for floral arrangements, candles, or unique decor pieces. Customizable to fit any wedding theme, they bring an extra touch of class to your special day.",
        category: ["Home Decor", "Wedding Favors"],
        tags: ["Centerpieces", "Decor", "Weddings"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Materials", content: "Flowers, Candles, Crystal, Glass" },
            { id: 2, title: "Size", content: "12 inches x 12 inches" }
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "Isabella Gray",
                date: "Feb 15, 2024",
                rating: 5,
                content: "The centerpieces were absolutely stunning! They really made the reception tables look amazing."
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Daniel Smith",
                date: "Jan 10, 2024",
                rating: 4,
                content: "Lovely centerpieces, though the delivery was a bit delayed. Still, they were perfect for our wedding theme!"
            }
        ]
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Gift Boxes",
        price: 19.99,
        disprice: 14.99,
        stock: 11,
        content: "Add a special touch to your wedding favors with our elegant gift boxes. Perfect for small gifts or keepsakes, these boxes come in various styles and can be personalized for an extra thoughtful detail.",
        description: "Our gift boxes are ideal for presenting wedding favors, thank you gifts, or keepsakes. Available in different designs, colors, and sizes, these boxes can be customized with names, dates, or messages to make them truly unique.",
        category: ["Wedding Favors", "Personalized Gifts"],
        tags: ["Gifts", "Favor", "Weddings"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Cardboard, Satin Ribbon, Paper" },
            { id: 2, title: "Size", content: "4x4x4 inches, 5x5x5 inches" }
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "Olivia Turner",
                date: "Feb 5, 2024",
                rating: 5,
                content: "These gift boxes were perfect for my wedding favors! The personalized touch made them even more special."
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Benjamin Scott",
                date: "Jan 20, 2024",
                rating: 5,
                content: "Beautiful boxes, exactly what I was looking for! Great quality and the customization was flawless."
            }
        ]
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: "Engagement Bands",
        price: 799.99,
        disprice: 699.99,
        stock: 8,
        content: "Celebrate your love with our exquisite engagement bands. Featuring stunning diamond settings and elegant designs, these bands are perfect for marking the beginning of your forever together.",
        description: "Our engagement bands are crafted with precision and care, offering timeless elegance. Available in a variety of styles, including solitaire, halo, and vintage designs, each band is made to fit your partner’s unique taste and style. Customize with your choice of metal and stone for a one-of-a-kind piece.",
        category: ["Wedding Jewelry", "Bridal Accessories"],
        tags: ["Rings", "Jewelry", "Engagement"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: "Materials", content: "Platinum, Gold, White Gold, Diamonds" },
            { id: 2, title: "Stone Type", content: "Round Cut Diamond, Princess Cut Diamond" }
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: "Sophia Lee",
                date: "Jan 22, 2024",
                rating: 5,
                content: "Absolutely in love with my engagement band! The diamond shines beautifully, and the design is so elegant."
            },
            {
                id: 2,
                image: images.product10Review2,
                name: "James Williams",
                date: "Dec 18, 2023",
                rating: 5,
                content: "A perfect engagement band! My fiancée adores it, and the quality is top-notch."
            }
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: "Bridal Footwear",
        price: 149.99,
        disprice: 129.99,
        stock: 20,
        content: "Step into elegance on your wedding day with our exclusive bridal footwear collection. Designed for comfort and style, these shoes are perfect for brides who want to look chic while feeling at ease.",
        description: "Our bridal footwear combines fashion and function, ensuring you can walk down the aisle with confidence. Whether you prefer classic pumps, elegant flats, or something with a little sparkle, we offer a variety of styles to suit every bride's preference.",
        category: ["Bridal Accessories", "Wedding Favors"],
        tags: ["Shoes", "Footwear", "Bridal"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: "Materials", content: "Satin, Leather, Crystal, Lace" },
            { id: 2, title: "Available Sizes", content: "5-11" }
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: "Hannah Moore",
                date: "Mar 10, 2024",
                rating: 5,
                content: "These shoes were perfect for my wedding day! They were so comfortable, and the sparkle added the right amount of glam."
            },
            {
                id: 2,
                image: images.product11Review2,
                name: "Chloe Adams",
                date: "Feb 28, 2024",
                rating: 5,
                content: "The best bridal shoes! Super comfortable and beautiful design. I was able to dance all night without any discomfort."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Gemstone Studs",
        price: 249.99,
        disprice: 199.99,
        stock: 12,
        content: "Add a pop of color and elegance with our stunning gemstone studs. Featuring a variety of precious stones, these earrings are perfect for brides looking to add a unique touch to their wedding day look.",
        description: "Our gemstone studs are available in a selection of vibrant stones, including sapphires, emeralds, and rubies. Set in high-quality settings, these earrings bring both sparkle and color, making them a versatile accessory for the wedding day or any special occasion.",
        category: ["Wedding Jewelry", "Bridal Accessories"],
        tags: ["Earrings", "Jewelry", "Accessories"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: "Materials", content: "Gold, Silver, Sapphire, Ruby, Emerald" },
            { id: 2, title: "Stone Size", content: "5mm" }
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: "Lily Evans",
                date: "Mar 15, 2024",
                rating: 5,
                content: "These gemstone studs were the perfect accessory for my wedding day. The color was vibrant, and they really stood out!"
            },
            {
                id: 2,
                image: images.product12Review2,
                name: "Oliver King",
                date: "Feb 5, 2024",
                rating: 4,
                content: "Beautiful earrings with great quality. My fiancée loved them, though I wish they came in larger sizes."
            }
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: "Custom Keychains",
        price: 12.99,
        disprice: 9.99,
        stock: 50,
        content: "Personalize your wedding favors with our custom keychains. Available in a variety of designs and materials, these keychains make great keepsakes for your guests.",
        description: "Our custom keychains are perfect for gifting to your wedding guests as a token of appreciation. Choose from a range of designs, colors, and materials, and add personalized engraving or messages to create a memorable favor that your guests will cherish.",
        category: ["Wedding Favors", "Personalized Gifts"],
        tags: ["Keychains", "Personalized", "Gifts"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: "Materials", content: "Wood, Acrylic, Metal" },
            { id: 2, title: "Customization", content: "Engraving, Colors, Design" }
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: "Emma Carter",
                date: "Jan 30, 2024",
                rating: 5,
                content: "These custom keychains were a hit at our wedding! The guests loved them, and the engraving was perfect."
            },
            {
                id: 2,
                image: images.product13Review2,
                name: "Lucas Wright",
                date: "Dec 15, 2023",
                rating: 4,
                content: "Great quality keychains, and the customization was just what I wanted. I would definitely recommend these as wedding favors."
            }
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: "Luxury Necklaces",
        price: 499.99,
        disprice: 399.99,
        stock: 8,
        content: "Make a statement with our exquisite luxury necklaces. Crafted with high-quality materials and adorned with diamonds, pearls, and precious stones, these necklaces add a touch of sophistication to any wedding ensemble.",
        description: "Our luxury necklaces are designed for brides who want to add a touch of opulence to their wedding day look. With intricate designs featuring diamonds, pearls, and colorful gemstones, these necklaces are perfect for a statement piece that will leave a lasting impression.",
        category: ["Wedding Jewelry", "Bridal Accessories"],
        tags: ["Necklaces", "Jewelry", "Luxury"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: "Materials", content: "Gold, Diamonds, Pearls, Sapphire" },
            { id: 2, title: "Length", content: "18 inches" }
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: "Sophia Lee",
                date: "Feb 20, 2024",
                rating: 5,
                content: "Absolutely stunning necklace! The diamonds sparkled so beautifully, and it was the perfect accessory for my wedding dress."
            },
            {
                id: 2,
                image: images.product14Review2,
                name: "Mia Davis",
                date: "Jan 10, 2024",
                rating: 5,
                content: "This necklace was the highlight of my wedding jewelry. It complemented my gown perfectly and made me feel like royalty."
            }
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: "Memory Frames",
        price: 39.99,
        disprice: 29.99,
        stock: 25,
        content: "Capture your special memories with our elegant memory frames. Perfect for framing your favorite wedding photos or keepsakes, these frames add a personal and sentimental touch to any home decor.",
        description: "Our memory frames are designed to showcase your most cherished moments. Whether it's a wedding photo, an engagement picture, or a family portrait, these frames will preserve your memories beautifully. Available in various sizes and finishes to match your home style.",
        category: ["Home Decor", "Personalized Gifts"],
        tags: ["Frames", "Decor", "Personalized"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: "Materials", content: "Wood, Glass, Metal" },
            { id: 2, title: "Dimensions", content: "5x7 inches, 8x10 inches" }
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: "Olivia Smith",
                date: "Mar 5, 2024",
                rating: 5,
                content: "These frames were perfect for our wedding photos. They added a touch of elegance to our living room, and we love how the memories are displayed."
            },
            {
                id: 2,
                image: images.product15Review2,
                name: "James Taylor",
                date: "Feb 25, 2024",
                rating: 4,
                content: "Good quality frames. I bought them as a gift for my wife, and she loved them. Would love more color options."
            }
        ]
    } 

];

export default products;